import { PageLayout } from "../components/PageLayout";
import { WebsocketConnections } from "../features/websockets/WebsocketConnections";

export const WebsocketConnectionsPage: React.FC = () => {
  return <PageLayout>
    <WebsocketConnections />
  </PageLayout>;
};